export default __webpack_public_path__ + "static/media/me11.553d74ce.gif";